import { lenis } from './lenis'

let bound = false

const getModal = () => document.querySelector('.newsletter-signup')

const openNewsletter = () => {
	const modal = getModal()

	if (!modal) return

	// The iframe ships without a src so we don't start an Acteol session on every page
	// view — load it the first time the modal is opened.
	const frame = modal.querySelector('[data-newsletter-src]')
	if (frame && !frame.src) frame.src = frame.dataset.newsletterSrc

	document.body.setAttribute('data-newsletter-status', 'active')
	modal.setAttribute('aria-hidden', 'false')
	lenis?.stop()
}

const closeNewsletter = () => {
	if (!document.body.hasAttribute('data-newsletter-status')) return

	document.body.removeAttribute('data-newsletter-status')
	getModal()?.setAttribute('aria-hidden', 'true')
	lenis?.start()
}

export const newsletter = () => {
	// Delegated so the flexible-content CTA works on Barba-transitioned pages without
	// needing to rebind, and so repeat calls can't double up listeners.
	if (bound) return
	bound = true

	document.addEventListener('click', e => {
		if (e.target.closest('[data-newsletter-form]')) {
			e.preventDefault()
			openNewsletter()
			return
		}

		if (e.target.closest('[data-exit-newsletter]')) {
			e.preventDefault()
			closeNewsletter()
		}
	})

	document.addEventListener('keydown', e => {
		if (e.key === 'Escape') closeNewsletter()
	})
}

export default () => { }
